/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".confirmation-dialog[_ngcontent-%COMP%]{max-width:25em}.confirmation-dialog[_ngcontent-%COMP%]   .mat-dialog-actions[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;margin-top:2em}"];
export { styles as styles };
